module.exports = __webpack_public_path__ + "static/media/next.ab854ab1.svg";